/**
 * Which tab is open lives in the URL, so a tab is linkable and survives a
 * reload — the same reason the list keeps its filters there.
 *
 * Hand-rolled rather than zod for the reason `search.ts` documents:
 * validateSearch stays in the eager route config, so a schema here ships zod
 * to every page load.
 */

export const CUSTOMER_TABS = [
  "visits",
  "usage",
  "people",
  "equipment",
  "fields",
  "support",
] as const;

export type CustomerTab = (typeof CUSTOMER_TABS)[number];

export const DEFAULT_CUSTOMER_TAB: CustomerTab = "visits";

export type CustomerDetailSearch = { tab?: CustomerTab };

export function isCustomerTab(value: unknown): value is CustomerTab {
  return CUSTOMER_TABS.includes(value as CustomerTab);
}

export function validateCustomerDetailSearch(
  raw: Record<string, unknown>
): CustomerDetailSearch {
  return { tab: isCustomerTab(raw.tab) ? raw.tab : DEFAULT_CUSTOMER_TAB };
}
